import { useMemo } from 'react';
export function usePublishStatus({ pages, selectedModules, selectedPages }) {
    return useMemo(() => {
        let hasPublished = false;
        let hasUnpublished = false;
        const hasSelectedModule = Object.values(selectedModules).some((selected) => selected);
        // Assume both statuses if the entire module is selected
        if (hasSelectedModule) {
            return { hasPublished: true, hasUnpublished: true };
        }
        pages.some((page) => {
            if (selectedPages[page.id]) {
                hasPublished = hasPublished || page.published;
                hasUnpublished = hasUnpublished || !page.published;
            }
            // Exit loop early if both are true
            return hasPublished && hasUnpublished;
        });
        return { hasPublished, hasUnpublished };
    }, [pages, selectedPages, selectedModules]);
}
